import clsx from 'clsx';
import { ReactElement, ComponentProps } from 'react';

export const ProviderCardGrid = ({
  className,
  ...props
}: ComponentProps<'div'>): ReactElement => {
  return (
    <div
      className={clsx(
        className,
        'grid grid-cols-[1fr_80px] gap-x-6 tablet:grid-cols-[1fr_170px] desktop:grid-cols-[120px_1fr_336px]',
        'tablet:grid-rows-[min-content_1fr_min-content]',
      )}
      {...props}
    />
  );
};
